import React, { useContext } from "react";
import { Switch, Route, } from "react-router-dom";
import { AppStateContext } from "../../app-state";
import { FullHeader } from "../common/header-and-footer/FullHeader";
import { SiteFooter } from "../common/header-and-footer/SiteFooter";
import { EventDetail } from "./detail/EventDetail";
export const EventMaster = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    return (React.createElement("div", { className: "event-master" },
        React.createElement(FullHeader, null),
        React.createElement("div", { className: "event-master-page" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/cs/aukce/:urlEventId" },
                    React.createElement(EventDetail, null)))),
        React.createElement(SiteFooter, null)));
};
